import TubCommon from "./tubCommon";
import {IS_LIXIL_SERVERS} from "../../../../../config";

export default class ReplacementTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'replacement_tub';
    this.bottomTubId = "replacement_tub";
    this.visible = true;
    this.partName = 'Replacement Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.replacement_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    this.canBeDisabled = IS_LIXIL_SERVERS; // request by Lixil
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  handleClick(...props) {
    if (this.isStandaloneReplacementTub(this)) {
      const bathtubParent = this.getParent().getParent().layout.parts.Bathtub;
      if (bathtubParent?.bathTubBody?.activeFeature && !bathtubParent.bathTubBody.disabled) {
        bathtubParent.bathTubBody.disabled = true;
        // bathtubParent.bathTubBody.disabledClick(); // can't do that, because we still need enclosures
        ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
          if (bathtubParent[relName]) {
            bathtubParent[relName].disabled = false;
          }
        })
      }
    }
    return super.handleClick(...props);
  }

  isStandaloneReplacementTub(forFeature = this.activeFeature) {
    return forFeature?.dbFeature?.metaData?.["MountType"]?.includes("D")
  }

  disabledClick() {
    const bathtubParent = this.getParent().layout.parts.Bathtub;
    ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
      if (bathtubParent[relName]) {
        bathtubParent[relName].disabled = this.disabled;
      }
    })
  }

}
